import { Fragment } from 'react';

import {
  Select,
  SelectClose,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
  SelectSeparator,
} from '@/components/ui/select';

import { useAuditLogs, dateRangeOptions, filterKeyGroups, type IDateRange, type IFilterKey } from '../model';

const AuditLogsFilters = () => {
  const { eventType, dateRange, setEventType, setDateRange, startTransition } = useAuditLogs();

  return (
    <div className="flex items-center gap-3">
      <Select
        value={dateRange ?? ''}
        onValueChange={(v) => startTransition(() => setDateRange((v as IDateRange) || null))}
      >
        <div className="relative">
          <SelectTrigger aria-label="Date range" className="w-50 bg-white" withCloseButton={Boolean(dateRange)}>
            <SelectValue placeholder="Filter by time range" />
          </SelectTrigger>
          <SelectClose isVisible={Boolean(dateRange)} onClose={() => setDateRange(null)} />
        </div>
        <SelectContent>
          {dateRangeOptions.map(({ label, value }) => (
            <SelectItem key={value} value={value}>
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select
        value={eventType ?? ''}
        onValueChange={(v) => startTransition(() => setEventType((v as IFilterKey) || null))}
      >
        <div className="relative">
          <SelectTrigger aria-label="Event type" className="w-50 bg-white" withCloseButton={Boolean(eventType)}>
            <SelectValue placeholder="Filter by scope" />
          </SelectTrigger>
          <SelectClose isVisible={Boolean(eventType)} onClose={() => setEventType(null)} />
        </div>
        <SelectContent className="max-h-95">
          {filterKeyGroups.map(({ label, options }, index) => (
            <Fragment key={label}>
              <SelectGroup key={label}>
                <SelectLabel>{label}</SelectLabel>
                {options.map(({ label, value }) => (
                  <SelectItem key={value} value={value}>
                    {label}
                  </SelectItem>
                ))}
              </SelectGroup>
              {index < filterKeyGroups.length - 1 && <SelectSeparator />}
            </Fragment>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default AuditLogsFilters;
